import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import cookie from "@/public/svg/cookie.svg";

const UMAMI_SCRIPT_ID = "umami-analytics-script";
const UMAMI_SCRIPT_SRC = import.meta.env.VITE_UMAMI_SRC;
const UMAMI_WEBSITE_ID = import.meta.env.VITE_UMAMI_WEBSITE_ID;

const startUmami = () => {
    if (!UMAMI_SCRIPT_SRC || !UMAMI_WEBSITE_ID) {
        return;
    }

    if (document.getElementById(UMAMI_SCRIPT_ID)) {
        return;
    }

    const script = document.createElement("script");
    script.id = UMAMI_SCRIPT_ID;
    script.defer = true;
    script.src = UMAMI_SCRIPT_SRC;
    script.setAttribute("data-website-id", UMAMI_WEBSITE_ID);
    document.head.appendChild(script);
};

const CookieBanner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const decision = localStorage.getItem("cookiesAccepted");

        if (decision === "true") {
            startUmami();
        }

        setVisible(decision === null);
    }, []);

    const handleAccept = () => {
        localStorage.setItem("cookiesAccepted", "true");
        startUmami();
        setVisible(false);
    };

    const handleDecline = () => {
        localStorage.setItem("cookiesAccepted", "false");
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="fixed bottom-0 left-0 w-full bg-white shadow-lg border-t border-gray-300 z-50">
            <div className="max-w-5xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-center">
                <img className="mr-4" src={cookie} alt="Cookie" loading="lazy" />
                <p className="text-sm text-gray-700 mr-8">
                    Diese Website verwendet keine Tracking-Cookies. Um Ihre Auswahl zur Webanalyse zu speichern, nutzen wir vergleichbare Technologien. Weitere Informationen finden Sie in der{" "}
                    <Link to="/datenschutz" className="underline text-primary hover:text-primaryDark">
                        Datenschutzerklärung
                    </Link>
                    .
                </p>
                <div className="flex gap-2">
                    <button
                        onClick={handleDecline}
                        className="bg-gray-200 text-gray-700 text-sm px-5 py-2 rounded-md hover:bg-gray-300 transition"
                    >
                        Ablehnen
                    </button>
                    <button
                        onClick={handleAccept}
                        className="bg-primary text-white text-sm px-5 py-2 rounded-md hover:bg-primaryDark transition"
                    >
                        Akzeptieren
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
